// Shared camera quaternion for syncing orientation cube with main scene camera
import * as THREE from 'three';

export const sharedCameraQuat = new THREE.Quaternion();
export const sharedCameraDir = new THREE.Vector3(0, 0, 1);
